import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class CheckoutLinkListService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      links: [],
      filter: '',
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
      },
    });
  }

  init = action(() => {
    this.links = [];
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  });

  load = action(() => {
    if (this.filter) {
      this.pagination = {
        ...this.pagination,
        current: 1,
      };
    }

    this.fetch
      .fetch({
        url: '/checkout-links',
        query: {
          criteria: this.filter,
          page: this.pagination.current,
          size: this.pagination.pageSize,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.links = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.links = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });

  handleFilterChange = action((value) => {
    this.filter = value;
    this.load();
  });

  handleChange = action((pagination) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.load();
  });

  handleRemove = action((checkoutLink) => {
    ConfirmationDialogService.show(
      'Delete Checkout link',
      `You are about to delete the Checkout link "${checkoutLink.name}", Do you want to continue?`,
      () => {
        this.fetch
          .fetch({
            url: `/checkout-links/${checkoutLink.id}`,
            method: 'delete',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(
                `Checkout link "${checkoutLink.name}" deleted successfully.`,
                'success'
              );
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const countryListService = new CheckoutLinkListService();

export default countryListService;
